import { z } from 'zod'

/**
 * 거래처 관리 API 계약 (BIZ-49).
 *
 * 회사가 거래처(고객사·기관·장례식장 등)를 등록·관리하고, 주문서에서 골라 쓴다. 주문은 선택한
 * 거래처의 이름을 partner_name으로 스냅샷한다(발신자·배송지와 같은 규칙). 관리=기업 관리자,
 * 조회·선택=담당자. 회사 안에서 이름은 유일(중복 등록 방지).
 */

export const companyPartnerResponse = z.object({
  id: z.number().int(),
  name: z.string(),
  memo: z.string().nullable(),
  displayOrder: z.number().int(),
})
export type CompanyPartnerResponse = z.infer<typeof companyPartnerResponse>

export const companyPartnerListResponse = z.object({
  items: z.array(companyPartnerResponse),
})
export type CompanyPartnerListResponse = z.infer<typeof companyPartnerListResponse>

const partnerName = z.string().trim().min(1, '거래처명을 입력하세요').max(100, '거래처명은 100자 이하여야 합니다')
const partnerMemo = z.string().trim().max(200, '메모는 200자 이하여야 합니다')

export const createCompanyPartnerRequest = z.object({
  name: partnerName,
  memo: partnerMemo.optional(),
  displayOrder: z.number().int().optional(),
})
export type CreateCompanyPartnerRequest = z.infer<typeof createCompanyPartnerRequest>

/** 부분 수정. 준 필드만 바꾼다. */
export const updateCompanyPartnerRequest = z
  .object({
    name: partnerName,
    memo: partnerMemo.nullable(),
    displayOrder: z.number().int(),
  })
  .partial()
export type UpdateCompanyPartnerRequest = z.infer<typeof updateCompanyPartnerRequest>

export const CompanyPartnerErrorCode = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'COMPANY_PARTNER_NOT_FOUND',
  NO_COMPANY: 'NO_COMPANY',
  FORBIDDEN: 'FORBIDDEN',
  DUPLICATE: 'COMPANY_PARTNER_DUPLICATE', // 같은 회사에 같은 이름이 이미 있다
} as const
export type CompanyPartnerErrorCode = (typeof CompanyPartnerErrorCode)[keyof typeof CompanyPartnerErrorCode]
